import jwt_decode from 'jwt-decode';

class Auth {
  static isAuthorized({ permission, dispatch }) {
    // todo: if no token then notAuthorized
    // todo: if token but no access then forbidden (not doing this for boilerplate
    const allowed = Auth.getToken();

    if (allowed) {
      return true;
    }

    return false;
  }

  static getToken() {
    return localStorage.getItem('token');
  }

  static setToken(token) {
    return localStorage.setItem('token', token);
  }

  static removeToken() {
    return localStorage.removeItem('token');
  }

  static getPayload() {
    const token = Auth.getToken();
    if (token) {
      const payload = jwt_decode(token);
      return payload;
    }
    return null;
  }

  static getUserType() {
    const payload = Auth.getPayload();
    return payload ? payload.type : null;

  }

  static isType(types) {
    const type = Auth.getUserType();
    if (!type) {
      return false;
    }
    if (Array.isArray(types)) {
      return types.indexOf(type) > -1;
    }
    return types === type;
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/app/libs/Auth.js